import React, { Component } from 'react';
import PropTypes from 'prop-types';

import AlertBox from './AlertBox';
import RoomBookingCalendarInput from './RoomBookingCalendarInput';
import RoomBookingCalendarHeader from './RoomBookingCalendarHeader';
import RoomBookingExistingBookingsCalendar from './RoomBookingExistingBookingsCalendar';
import RoomBookingAvailableBookingsCalendar from './RoomBookingAvailableBookingsCalendar';
import ModalTrigger from './ModalTrigger';

export default class RoomBookingCalendarWrapper extends Component {
  static propTypes = {
    rooms: PropTypes.object.isRequired,
    availableBookings: PropTypes.object.isRequired,
    existingBookings: PropTypes.object.isRequired,
    defaultLocation: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    bookARoomUrl: PropTypes.string,
    allBookingsUrl: PropTypes.string,
    existingBookingsUrl: PropTypes.string,
    source: PropTypes.string.isRequired,
    locationData: PropTypes.array.isRequired,
    useTimezone: PropTypes.string.isRequired,
    userSuggestionUrl: PropTypes.string,
  };

  static defaultProps = {
    bookARoomUrl: '',
    allBookingsUrl: '',
    existingBookingsUrl: '',
    userSuggestionUrl: '',
  };

  constructor(props) {
    super(props);
    const showBookOnBehalfInput = this.props.userSuggestionUrl !== '';

    this.state = {
      rooms: this.props.rooms,
      currentRooms: this.props.rooms[this.props.defaultLocation].rooms,
      location: this.props.defaultLocation,
      date: this.props.date,
      existingBookings: this.props.existingBookings,
      availableBookings: this.props.availableBookings,
      duration: 30,
      type: 'available',
      halfHours: this.getHalfHours(moment(this.props.date).toDate()),
      message: '',
      useTimezone: this.props.useTimezone,
      scrollIndex: 0,
      showBookOnBehalfInput,
    };
  }

  componentDidMount() {
    $('.BookingCalendar').scrollTop(moment().hours() * 89);
    this.handleScroll();
  }

  componentDidUpdate() {
    this.handleScroll();
  }

  //
  // AJAX
  //

  getCalendars(searchLocation, searchDate, searchDuration) {
    $.ajax({
      url: this.props.source,
      type: 'get',
      data: {
        location: searchLocation,
        date: moment(searchDate).format('MMMM DD, YYYY'),
        duration: searchDuration,
      },
      dataType: 'json',
      success: function(result) {
        this.setState({
          currentRooms: this.state.rooms[searchLocation].rooms,
          location: searchLocation,
          halfHours: this.getHalfHours(searchDate),
          date: searchDate,
          duration: searchDuration,
          existingBookings: result.existing_bookings,
          availableBookings: result.available_bookings,
          useTimezone: result.use_timezone,
        });
      }.bind(this),
    });
  }

  //
  // CHILD CALLBACKS
  //

  handleLocationChange = searchLocation => {
    this.getCalendars(searchLocation, this.state.date, this.state.duration);
  };

  // Note: searchDate is sometimes being returned by RoomBookingCalendarInput as
  // a 'date' rather than a 'string', which is causing a 'failed prop type' warning.
  handleDateChange = searchDate => {
    this.getCalendars(this.state.location, searchDate, this.state.duration);
  };

  handleDurationChange = searchDuration => {
    this.getCalendars(this.state.location, this.state.date, searchDuration);
  };

  handleNewBooking = data => {
    this.setState({
      availableBookings: data.availableBookings,
      existingBookings: data.existingBookings,
      message: data.message,
      error: data.error,
    });
  };

  handleAlertClick = () => {
    this.setState({ message: '' });
  };

  //
  // VIEW TOGGLES
  //

  toggleAvailableView = () => {
    this.setState({ type: 'available' }, function() {});
  };

  toggleBookedView = () => {
    this.setState({ type: 'booked' }, function() {});
  };

  //
  // UI HELPERS
  //

  scroll() {
    const scrollTo = this.state.scrollIndex * $('.BookingCalendar-roomsContainer').width();
    $('.BookingCalendar-roomsContainer')
      .stop()
      .animate({ scrollLeft: scrollTo }, 750);
  }

  handleScroll() {
    const currentCalendar = `#${this.state.type}-rooms`;
    const firstRoomIndex = this.state.scrollIndex * 4;
    const lastRoomIndex = firstRoomIndex + 6;

    $(currentCalendar)
      .children('.col')
      .removeClass('firstShown');
    $(currentCalendar)
      .children('.col')
      .removeClass('lastShown');

    $(currentCalendar)
      .children('.col')
      .eq(firstRoomIndex)
      .addClass('firstShown');
    $(currentCalendar)
      .children('.col')
      .eq(lastRoomIndex)
      .addClass('lastShown');
  }

  scrollLeft = () => {
    // Don't scroll left if we're already as far left as we can be
    if (!(this.state.scrollIndex === 0)) {
      this.setState({ scrollIndex: this.state.scrollIndex - 1 }, function() {
        this.scroll();
      });
    }
  };

  scrollRight = () => {
    const numberOfRooms = Object.keys(this.state.currentRooms).length;
    // Don't scroll right if the next index would try to show more than the
    // total number of rooms
    if (!((this.state.scrollIndex + 1) * 4 >= numberOfRooms)) {
      this.setState({ scrollIndex: this.state.scrollIndex + 1 }, function() {
        this.scroll();
      });
    }
  };

  //
  // HELPERS
  //

  getHalfHours(date) {
    const dateInBrowserTimezone = moment(
      moment(date).format("dddd, MMMM D, YYYY, h:mm A'"),
      'dddd, MMMM D, YYYY, h:mm A'
    );
    const halfHourIncrement = dateInBrowserTimezone.clone().startOf('day');
    const endOfDay = dateInBrowserTimezone
      .clone()
      .hour(23)
      .minutes(59);
    const halfHours = [];
    while (halfHourIncrement < endOfDay) {
      halfHours.push(halfHourIncrement.clone());
      halfHourIncrement.add(30, 'minutes');
    }
    return halfHours;
  }

  sortRoomsAlphabetically = () => {
    const rooms = this.state.currentRooms;
    return Object.keys(rooms).sort((a, b) => {
      const nameA = rooms[a].name.toUpperCase();
      const nameB = rooms[b].name.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      // If names are equal
      return 0;
    });
  };

  render() {
    const containerClasses = `row RoomSearch ${
      this.state.showBookOnBehalfInput ? '' : 'Container'
    }`;
    let bookARoomButton;
    let myBookingsButton;

    if (!this.state.showBookOnBehalfInput) {
      bookARoomButton = (
        <a className="Button Button--small u-float-right u-mr-4" href={this.props.bookARoomUrl}>
          <i className="Icon Icon-plus-square u-mr-2" />
          Book a Room
        </a>
      );

      myBookingsButton = (
        <ModalTrigger
          triggerIcon="Icon Icon-event-available u-mr-2"
          triggerLabel="My Bookings"
          triggerClassName="Button Button--small u-float-right"
          async
          asyncUrl={this.props.existingBookingsUrl}
        />
      );
    }

    const numberOfRooms = Object.keys(this.state.currentRooms).length;
    return (
      <div className={`u-main u-relative ${this.state.message ? 'u-mt-0 u-pt-20' : ''}`}>
        <div className="u-absolute u-top-0 u-left-0 u-right-0 h-12">
          <AlertBox
            message={this.state.message}
            type={this.state.bookingError ? 'alert' : 'notice'}
            onClick={this.handleAlertClick}
            dismissable
          />
        </div>
        <div className="u-sidebar">
          <h3 className="u-panel-heading u-mb-4">View</h3>
          <ul className="List List--multiple List--medium u-panel">
            <li>
              <a className="u-block" href={this.props.bookARoomUrl}>
                Room Booking
              </a>
            </li>
            <li className="u-font-semibold">
              <a className="u-block" href={this.props.source}>
                Room Calendar
              </a>
            </li>
          </ul>
        </div>
        <div className="u-content">
          <div className={containerClasses}>
            <div className="RoomSearch-input ">
              <h3 className="u-panel-heading u-mb-4">Filters</h3>
              <div className="u-panel u-p-5 u-mb-4">
                <div className="u-clearfix">
                  {myBookingsButton}
                  <h3 className="u-inline-block">Room booking calendar</h3>
                  <RoomBookingCalendarInput
                    locationData={this.props.locationData}
                    locationDefault={this.state.location}
                    locationCallback={this.handleLocationChange}
                    dateDefault={moment(this.state.date).format()}
                    dateCallback={this.handleDateChange}
                    type={this.state.type}
                    availableCallback={this.toggleAvailableView}
                    bookedCallback={this.toggleBookedView}
                    durationCallback={this.handleDurationChange}
                    useTimezone={this.state.useTimezone}
                  />
                </div>
              </div>
            </div>
            <h3 className="u-panel-heading u-mb-4">Calendar</h3>
            <div className="u-panel u-p-5">
              <div className="u-clearfix">
                <div className="u-mb-4" hidden={this.state.type === 'booked' && numberOfRooms < 4}>
                  <div className="u-hintText md:u-flex md:u-flex-row md:u-justify-between md:u-items-center">
                    <div hidden={this.state.type === 'booked'}>
                      Click on the calendar to reserve a room
                    </div>
                    <div hidden={numberOfRooms < 4} className="u-float-right">
                      <span className="u-mr-4">Showing 4 of {numberOfRooms} rooms</span>
                      <ul className="button-group radius u-inline-block">
                        <a
                          className={`Button Button--scope Button--xsmall${
                            this.state.scrollIndex === 0 ? ' is-active' : ''
                          }`}
                          onClick={this.scrollLeft}
                          role="button">
                          <i className="Icon Icon-chevron-left" />
                        </a>
                        <a
                          className={`Button Button--scope Button--xsmall${
                            (this.state.scrollIndex + 1) * 4 >= numberOfRooms ? ' is-active' : ''
                          }`}
                          onClick={this.scrollRight}
                          role="button">
                          <i className="Icon Icon-chevron-right" />
                        </a>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="BookingCalendar-hourColumn" />
                <div className="BookingCalendar-roomsContainer">
                  {this.sortRoomsAlphabetically().map((roomId, index) => (
                    <RoomBookingCalendarHeader
                      key={index}
                      id={index}
                      name={this.state.currentRooms[roomId].name}
                      attributes={this.state.currentRooms[roomId].attributes}
                    />
                  ))}
                </div>
                <div className="BookingCalendar">
                  <div className="BookingCalendar-hourColumn">
                    {this.state.halfHours.map(halfHour => (
                      <div className="BookingCalendar-halfHourSlot" key={halfHour.format('h:mm A')}>
                        <span>{halfHour.format('h:mm A')}</span>
                      </div>
                    ))}
                  </div>
                  <div className="BookingCalendar-roomsContainer">
                    <div hidden={this.state.type === 'available'}>
                      <RoomBookingExistingBookingsCalendar
                        date={this.state.date}
                        hidden={this.state.type === 'available'}
                        existingBookings={this.state.existingBookings}
                        halfHours={this.state.halfHours}
                        useTimezone={this.state.useTimezone}
                        sortedRooms={this.sortRoomsAlphabetically()}
                      />
                    </div>

                    <div hidden={this.state.type === 'booked'}>
                      <RoomBookingAvailableBookingsCalendar
                        date={this.state.date}
                        hidden={this.state.type === 'booked'}
                        availableBookings={this.state.availableBookings}
                        halfHours={this.state.halfHours}
                        duration={this.state.duration}
                        newBookingCallback={this.handleNewBooking}
                        newBookingBaseUrl={this.props.bookARoomUrl}
                        location={this.state.location}
                        useTimezone={this.state.useTimezone}
                        sortedRooms={this.sortRoomsAlphabetically()}
                        userSuggestionUrl={this.props.userSuggestionUrl}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
